import React from "react";
import Footer from "./footer";
import { useLanguage } from "../LanguageContext";
import { FileText } from "lucide-react";
import jsPDF from "jspdf";
import brochureImg from "../assets/products/hmi/hmiscada.png";

const ProductSCADA = () => {
    const { language } = useLanguage();

    const text = {
        en: {
            title: "SCADA Air Monitoring System",
            subtitle:
                "The SCADA Air Monitoring System provides real-time supervision of water distribution networks, enabling precise control of pump operations, water flow, and quality parameters through an integrated dashboard interface.",
            download: "Download the brochure",
            specTitle: "Specification",
            features: [
                { icon: require("../assets/products/hmi/real.png"), label: "Real-time Monitoring" },
                { icon: require("../assets/products/hmi/map.png"), label: "Geographical Visualization" },
                { icon: require("../assets/products/hmi/quality.png"), label: "Water Quality Analysis" },
                { icon: require("../assets/products/hmi/chart.png"), label: "Production & Demand Graphs" },
            ],
            specs: [
                {
                    title: "System Overview",
                    desc: [
                        "SCADA-based platform for water network monitoring and control.",
                        "Integrates flow meter, volume meter, and water quality sensors in one interface.",
                        "Supports automatic alarm notifications for pump operations and water parameters.",
                    ],
                },
                {
                    title: "Main Features",
                    desc: [
                        "Displays real-time water flow, stock, and demand status per station.",
                        "Visualizes water routes and equipment locations on a live map.",
                        "Monitors pH, turbidity, and TDS for water quality tracking.",
                        "Provides production and supply-demand forecasting charts.",
                    ],
                },
            ],
        },

        id: {
            title: "Sistem Pemantauan SCADA Air",
            subtitle:
                "Sistem Pemantauan SCADA Air berfungsi untuk mengawasi distribusi air secara real-time, mengontrol operasi pompa, aliran air, serta parameter kualitas air melalui tampilan dashboard yang terintegrasi.",
            download: "Unduh Brosur",
            specTitle: "Spesifikasi",
            features: [
                { icon: require("../assets/products/hmi/real.png"), label: "Pemantauan Real-time" },
                { icon: require("../assets/products/hmi/map.png"), label: "Visualisasi Peta Geografis" },
                { icon: require("../assets/products/hmi/quality.png"), label: "Analisis Kualitas Air" },
                { icon: require("../assets/products/hmi/chart.png"), label: "Grafik Produksi & Permintaan" },
            ],
            specs: [
                {
                    title: "Gambaran Sistem",
                    desc: [
                        "Platform berbasis SCADA untuk pemantauan dan pengendalian jaringan air.",
                        "Mengintegrasikan flow meter, volume meter, dan sensor kualitas air dalam satu tampilan.",
                        "Mendukung notifikasi alarm otomatis untuk operasi pompa dan parameter air.",
                    ],
                },
                {
                    title: "Fitur Utama",
                    desc: [
                        "Menampilkan data aliran air, stok, dan permintaan setiap rumah pompa secara real-time.",
                        "Memvisualisasikan jalur distribusi air dan lokasi peralatan di peta langsung.",
                        "Memantau pH, kekeruhan, dan TDS untuk pengawasan kualitas air.",
                        "Menyediakan grafik produksi harian dan perkiraan supply-demand.",
                    ],
                },
            ],
        },
    };

    const t = text[language] || text.en;

    const handleDownloadPDF = () => {
        const img = new Image();
        img.src = brochureImg;
        img.onload = () => {
            const pdf = new jsPDF("p", "mm", "a4");
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pageWidth;
            const imgHeight = (img.height * imgWidth) / img.width;
            let y = 0;
            if (imgHeight < pageHeight) y = (pageHeight - imgHeight) / 2;
            pdf.addImage(img, "PNG", 0, y, imgWidth, imgHeight);
            pdf.save("SCADA-Air-Monitoring-Brochure.pdf");
        };
    };

    return (
        <div className="font-inter text-gray-900 px-4 sm:px-8 md:px-20 lg:px-40">
            <section
                className="relative flex flex-col md:flex-row-reverse items-center justify-between 
         px-4 sm:px-6 md:px-10 py-10 sm:py-14 md:py-20 
         mx-4 sm:mx-6 md:mx-10 
         mt-20 sm:mt-14 md:mt-20 
         overflow-hidden rounded-[40px] 
         shadow-[0_25px_60px_rgba(55,140,231,0.5)]"
                style={{
                    background:
                        "linear-gradient(100deg, #EAF4FF 10%, #FFFFFF 40%, #2A4EA1 100%)",
                }}
            >
                <div className="w-full md:w-1/2 mb-6 md:mb-0 flex justify-center z-10">
                    <img
                        src={require("../assets/products/hmi/hmiscada.png")}
                        alt={t.title}
                        className="w-full max-w-[700px] sm:max-w-[800px] object-contain drop-shadow-[0_20px_50px_rgba(55,140,231,0.6)] transition-transform duration-500 ease-out"
                    />
                </div>

                <div className="w-full md:w-1/2 z-20 text-left text-[#1446A5] md:pr-10 sm:md:pr-20">
                    <h1 className="text-2xl sm:text-3xl md:text-3xl font-extrabold mb-4 sm:mb-6 leading-snug">
                        {t.title}
                    </h1>

                    <h2 className="text-lg sm:text-xl md:text-lg opacity-100 font-medium mb-4 sm:mb-6 leading-relaxed max-w-[400px] sm:max-w-[480px]">
                        {t.subtitle}
                    </h2>

                    {/* <button
                        onClick={handleDownloadPDF}
                        className="bg-[#2652A4] text-white font-semibold px-4 sm:px-6 py-2 sm:py-3 rounded-full shadow-lg hover:shadow-xl flex items-center gap-2 transition-all transform hover:scale-105"
                    >
                        {t.download}
                        <FileText className="w-4 sm:w-5 h-4 sm:h-5" />
                    </button> */}

                    <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
                        {t.features.map((f, i) => (
                            <div key={i} className="flex flex-col items-center">
                                <img src={f.icon} alt={f.label} className="w-8 sm:w-10 md:w-12 mb-2" />
                                <p className="text-[#1446A5] text-xs sm:text-sm font-medium leading-snug">
                                    {f.label}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="px-4 sm:px-6 md:px-10 py-8 sm:py-12 md:py-18 mt-20">
                <div className="block md:hidden mb-6">
                    <h3 className="text-[#1446A5] text-2xl sm:text-3xl font-extrabold leading-loose tracking-widest">
                        {t.specTitle}
                    </h3>
                </div>

                <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:gap-12 items-start">
                    <div className="order-2 md:order-1 md:w-1/2 flex justify-center md:justify-start">
                        <h3 className="text-[#1446A5] hidden md:block text-3xl sm:text-4xl md:text-6xl font-extrabold leading-loose tracking-widest md:mt-32 ml-0">
                            {t.specTitle}
                        </h3>
                    </div>

                    <div className="order-1 md:order-2 md:w-1/2 flex flex-col justify-start h-full">
                        <div className="grid grid-rows-2">
                            {t.specs.map((spec, i) => (
                                <div
                                    key={i}
                                    className="bg-white rounded-xl p-6 flex flex-col h-auto"
                                >
                                    <div>
                                        <h4 className="font-semibold mb-3 text-lg sm:text-xl text-[#1446A5]">
                                            {spec.title}
                                        </h4>

                                        {Array.isArray(spec.desc) ? (
                                            spec.title === "Fitur Utama" || spec.title === "Main Features" ? (
                                                <ul className="mt-1 text-gray-700 space-y-1 list-disc ml-4">
                                                    {spec.desc.map((d, idx) => (
                                                        <li key={idx} className="text-sm sm:text-base leading-relaxed">
                                                            {d}
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <div className="mt-1 text-gray-700 space-y-1">
                                                    {spec.desc.map((d, idx) => (
                                                        <p key={idx} className="text-sm sm:text-base leading-relaxed">
                                                            {d}
                                                        </p>
                                                    ))}
                                                </div>
                                            )
                                        ) : (
                                            <p className="mt-1 text-gray-700 text-sm sm:text-base leading-relaxed whitespace-pre-line">
                                                {spec.desc}
                                            </p>
                                        )}

                                    </div>
                                    <div className="mt-4 border-b border-gray-300 w-full" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>


            <Footer />
        </div>
    );
};

export default ProductSCADA;
